import BaseResource from './base-resource';
import JsonApiResource from './jsonapi-resource';
import ReferenceResolver from './reference-resolver';

export default class PermissionResource extends BaseResource {
  model: string;
  action: string;

  constructor(init?: Partial<PermissionResource>) {
    super(init, 'permissions');
    this.initialize(init);
  }
}



// WEBPACK FOOTER //
// ./common/models/permission-resource.ts